import script from "./ModalSide.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSide.vue?vue&type=script&setup=true&lang=js"

import "./ModalSide.vue?vue&type=style&index=0&id=73ab1679&lang=scss"

const __exports__ = script;

export default __exports__